import { render, staticRenderFns } from "./Customer2FA.vue?vue&type=template&id=1c85cc87&"
import script from "./Customer2FA.vue?vue&type=script&lang=js&"
export * from "./Customer2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports